import {
    Orientation,
    RemoteMode,
    PlayerPlayMode,
} from '@kinopoisk-int/evgen-web-events/web/named_enums';

import { PlayerBaseInfoContent } from '../../../player-manager/context/PlayerBaseInfoProvider';
import { buildPlayerArgsFromPlayerBaseInfoContent } from '../readers/read-player-args';

const defaultPlayerMeta = {
    orientation: Orientation.Horizontal,
    remoteMode: RemoteMode.Disabled,
    playMode: PlayerPlayMode.Online,
};

interface Params {
    contentId: string;
    psid: string;
    manifestUrl: string;
    vsid: string;
    isDynamicPrerollEnabled: boolean;
    content: PlayerBaseInfoContent;
}

export function playerContentPrepared(params: Params) {
    const { vsid, content, contentId, ...restCallbackParams } = params;

    const evgenParams = buildPlayerArgsFromPlayerBaseInfoContent(content, contentId);

    return { vsid, contentId, ...defaultPlayerMeta, ...restCallbackParams, ...evgenParams };
}
